import Link from "next/link";

import { Icon } from "@/components/ui/icon";
import { LayoutNavItem } from "@/types";

import { HeaderReturnVariantProps } from "./header.variants";

interface HeaderNavProps {
  styles: HeaderReturnVariantProps;
  menu: LayoutNavItem[];
  onHandleOpenSideMenu: (active: boolean, category: string) => void;
  onHandleMenu: (active: boolean) => void;
}

function HeaderNav({ styles, menu, onHandleOpenSideMenu, onHandleMenu }: HeaderNavProps) {
  return (
    <nav className={styles.nav()}>
      <ul className={styles.menu()}>
        {menu.map((item) => {
          const isDocsLink = item.link && item.link?.includes("/docs/");
          return (
            <li key={item.id} className={styles.menuItemWrapper()}>
              <Link
                href={item.link ?? "/"}
                aria-current={item.active ? "page" : undefined}
                target={item.openNewWindow ? "_blank" : undefined}
                className={styles.menuItem({
                  className: isDocsLink ? "mobile:hidden" : "",
                })}
                onClick={() => onHandleMenu(false)}
                scroll={true}
              >
                {item.startIcon && (
                  <Icon name={item.startIcon} className={styles.menuItemIcon()} />
                )}
                {item.title}
                {item.endIcon && (
                  <Icon name={item.endIcon} className={styles.menuItemIcon()} />
                )}
              </Link>
              {isDocsLink && (
                <Link
                  href="#"
                  aria-current={item.active ? "page" : undefined}
                  className={styles.menuItem({
                    className: "desktop:hidden w-full justify-between",
                  })}
                  onClick={() =>
                    onHandleOpenSideMenu(true, item.link?.split("/")[2] ?? "")
                  }
                  scroll={true}
                >
                  {item.title}
                  <Icon name="chevron_right" className={styles.menuItemIcon()} />
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default HeaderNav;
